import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative z-0',
    wrapper: 'group/sort relative flex items-center justify-end',
    label: 'sr-only',
    input:
      'peer invalid:text-error-error placeholder:text-bg-items-black disabled:placeholder:text-inactive disabled:text-inactive text-bg--items-black group-hover/sort:text-brand-400 block field-sizing-content w-auto max-w-[calc(100%-24px)] appearance-none pr-3 pl-2 font-light outline-none focus:outline-none',
    helperText: 'text-inactive px-4 pt-1 text-sm font-light',
    startAdornment: 'group-hover/sort:[&>path]:stroke-brand-400 h-6',
    endAdornment: 'h-6'
  },
  variants: {
    error: {
      true: {
        helperText: 'text-text-error',
        input: 'text-text-error placeholder:text-text-error'
      }
    },
    withBorder: {
      true: {
        wrapper: 'invalid:border-bg-delete-error border-b-1 border-black'
      },
      false: {
        wrapper: ''
      }
    },
    type: {
      header: {
        wrapper: 'justify-start gap-1 pl-3',
        input:
          'text-icon-main-inversion placeholder:text-icon-main-inversion group-hover/sort:text-icon-main-inversion grow py-3'
      }
    }
  },
  compoundVariants: [
    {
      type: 'header',
      withBorder: true,
      className: {
        wrapper: 'border-white'
      }
    }
  ],
  defaultVariants: {
    withBorder: true
  }
});
